import { a6 as attr, P as pop, N as push } from "../../../../../chunks/index.js";
import { L as Logo } from "../../../../../chunks/Logo.js";
import { B as Button } from "../../../../../chunks/Button.js";
import "../../../../../chunks/client.js";
function _page($$payload, $$props) {
  push();
  let email = "";
  let password = "";
  $$payload.out += `<div class="w-full h-full bg-zinc-100"><div class="grid grid-cols-6 container mx-auto border-l-2 border-dashed border-zinc-200/50 h-full"><div class="col-span-1 px-4 py-12">`;
  Logo($$payload);
  $$payload.out += `<!----></div> <div class="col-span-4 h-full"><div class="h-full mx-auto border-l-2 border-r-2 border-zinc-200/50 border-dashed flex items-center justify-center"><div class="bg-white p-12 rounded-lg shadow-md border row-span-4 w-full max-w-md mx-auto flex flex-col justify-center"><h1 class="text-2xl font-bold text-left mb-4 text-zinc-900">Sign in to your account</h1> <div class="mt-2 flex flex-col gap-4"><div><label class="block text-sm font-medium text-gray-700" for="email">Email</label> <input${attr("value", email)} class="mt-1 block w-full p-3 border border-gray-200 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 text-sm" id="email" name="email" type="email"></div> <div><label class="block text-sm font-medium text-gray-700" for="password">License</label> <input${attr("value", password)} class="mt-1 block w-full p-3 border border-gray-200 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 text-sm" id="password" name="password" type="password"></div> `;
  {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]--> <div class="mt-4">`;
  Button($$payload, {
    class: "rounded-md items-center shadow-sm border border-transparent hover:border-gray-100 hover:shadow-sm",
    endIcon: "mdi:login",
    label: "Login"
  });
  $$payload.out += `<!----></div></div></div></div></div> <div class="col-span-1"></div></div></div>`;
  pop();
}
export {
  _page as default
};
